import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import structure_urnii from "../../../images/structure/structure_urnii.png";
import structure2_urnii from "../../../images/structure/OsnYst.jpg";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Structure() {
  useSEO(seoConfig.structure);

  return (
    <section className="structure">
      <Breadcrumbs />

      <h1 className="contacts__title history__title structure__title">
        Структура института
      </h1>
      <img
        alt="Структура института"
        className="history__image structure__image"
        src={structure_urnii}
      ></img>

      <a
        href="/files/structure/structura_NII.pdf"
        download
        class="structure__download-link"
      >
        📥 Скачать PDF
      </a>

      <img
        alt="Основные уставные виды деятельности института"
        className="history__image structure__image"
        src={structure2_urnii}
      ></img>
      <div>
        <p></p>
      </div>
    </section>
  );
}
